import React from 'react'
import ContextMenu from './ContextMenu';
import { MenuItem, MenuList, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

const DynamicClauseContextMenu = (props) => {
    const {selectedClause, arg ,setArg, treeUpdate ,setSelectedClause ,updateFunction, clauseDisable} = props;

    const {t} = useTranslation();
    const handleNewClause = () =>{
      const treeData = [...(cloneDeep(arg) || [])];
      const newNode ={
        "ARGNAME": "%UNNAMED%",
        "ARGTYPE": "IN",
        "FIELDTYPE": "ALPHA"
      }
      treeData.push(newNode);
      updateFunction( "ARG" ,treeData);
      setArg(treeData)
      setSelectedClause([`cl-${treeData.length-1}`]);
      treeUpdate(treeData);
    }
  
    const handleDeleteClause =() =>{
      const treeData = [...cloneDeep(arg)];
      const index = Number(selectedClause[0].split('-')[1]);
      
      treeData.splice(index,1);
      setArg(treeData)
      updateFunction( "ARG" ,treeData);
      treeUpdate(treeData);
      if(!treeData.length)setSelectedClause([]);
      else if(index === 0) setSelectedClause([`cl-0`]);
      else setSelectedClause([`cl-${index-1}`]);
    }

    return (
        <ContextMenu targetId="dynamicClause">
          <Paper style={{ width: "19rem" }}>
            <MenuList vertical="true">
              <MenuItem disabled={clauseDisable} onClick={handleNewClause} name={t("MNU_NEW_DYNAMIC_CLAUSE_VALUE")}>
                <span className={"QUERY"}></span>
                <span className={"margin-left-8"}>
                  {t("MNU_NEW_DYNAMIC_CLAUSE_VALUE")}
                </span>
              </MenuItem>
              <MenuItem disabled={!selectedClause.length} onClick={handleDeleteClause} name={t("MNU_DEL_DYNAMIC_CLAUSE_VALUE")}>
                <span className={"SYMBOL_DELETE"}></span>
                <span className={"margin-left-8"}>{t("MNU_DEL_DYNAMIC_CLAUSE_VALUE")}</span>
              </MenuItem>
            </MenuList>
          </Paper>
        </ContextMenu>
      );
}

export default DynamicClauseContextMenu